import React from "react";
import Export from "components/DataEntryExport";

const ServicesExport = () => (
  <Export title="Services Export" action="services" />
);

export default ServicesExport;
